import styled from 'styled-components';

import { H3, Text } from '@catalyze/ui';

export const Container = styled.section`
    width: 100%;
    border-radius: 0.5rem;
    border: 1px solid ${({ theme }) => theme.colors.mediumShadow};
    padding: 1.5rem;
    display: flex;
    flex-flow: column;

    & > div {
        margin-bottom: 1.25rem;
        flex-wrap: wrap;

        &:last-child {
            margin-bottom: 0;
        }
    }
`;

export const FormSubtitle = styled(Text)`
    margin: 1rem 0;
    color: ${({ theme }) => theme.colors.fontTertiary};
    font-size: ${({ theme }) => theme.fontSizes[4]};
    text-align: left;
`;

export const Row = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-end;
`;

export const Title = styled(H3).attrs({ as: 'h1' })`
    font-weight: 700;
`;

export const Price = styled.h3`
    font-weight: 700;
    font-size: 3rem;
    line-height: 1.1666666667;
`;

export const Price2 = styled.h2`
    font-weight: 700;
    font-size: 1rem;
    line-height: 1.5;
`;

export const BillingPeriod = styled.h2`
    font-weight: 400;
    font-size: ${({ theme }) => theme.fontSizes[5]};
    color: ${({ theme }) => theme.colors.fontTertiary};
    margin-bottom: 0.5rem;
    margin-left: 0.25rem;
`;

export const BillingPeriod2 = styled.h2`
    font-weight: 400;
    font-size: ${({ theme }) => theme.fontSizes[5]};
    color: ${({ theme }) => theme.colors.fontTertiary};
    margin-left: 0.25rem;
`;
